// A service a Company's own captured pages say it offers. Ported from main's
// website-classification enum (`script/signal/11-website-research.ts`).
export enum CompanyService {
  SOLAR = "solar",
  ELECTRICAL = "electrical",
  ROOFING = "roofing",
  GENERAL_CONSTRUCTION = "general_construction",
  HVAC = "hvac",
  SOLAR_CLEANING = "solar_cleaning",
  BATTERY = "battery",
  EV_CHARGING = "ev_charging",
  CONSULTING = "consulting",
  FINANCING = "financing",
  DISTRIBUTION = "distribution",
  OTHER = "other",
}

export const dataByCompanyService: Record<CompanyService, { label: string }> = {
  [CompanyService.SOLAR]: { label: "Solar" },
  [CompanyService.ELECTRICAL]: { label: "Electrical" },
  [CompanyService.ROOFING]: { label: "Roofing" },
  [CompanyService.GENERAL_CONSTRUCTION]: { label: "General construction" },
  [CompanyService.HVAC]: { label: "HVAC" },
  [CompanyService.SOLAR_CLEANING]: { label: "Solar cleaning" },
  [CompanyService.BATTERY]: { label: "Battery storage" },
  [CompanyService.EV_CHARGING]: { label: "EV charging" },
  [CompanyService.CONSULTING]: { label: "Consulting" },
  [CompanyService.FINANCING]: { label: "Financing" },
  [CompanyService.DISTRIBUTION]: { label: "Distribution" },
  [CompanyService.OTHER]: { label: "Other" },
}
